const ACTIVITY_TYPES = {
  session: 1,
  assessment: 2,
  assignment: 3,
};

const ACTIVITY_TYPE_NAMES = {
  1: 'session',
  2: 'assessment',
  3: 'assignment',
};

// Exports
// -------

export { ACTIVITY_TYPES, ACTIVITY_TYPE_NAMES };

export default ACTIVITY_TYPES;
